import Context from "shared/util/Context";
import Analytics from "analytics/util/Analytics";
import UrlHelpers from "shared/util/UrlHelpers";
import React, { useEffect } from "react";
import PropTypes from "prop-types";

import {
	useSpring,
	animated,
} from "react-spring";

import PrematchIntro
	from "apps/messenger/components/Connections/Prematch/PrematchIntro";

import PostmatchIntro
	from "apps/messenger/components/Connections/Postmatch/Intro";

import { useMeasure } from "shared/components/Measured";

import "apps/messenger/components/Connections/index.scss";

function useAnalyticEvent({ likedVia, targetUser }) {
	useEffect(() => {
		if (!likedVia || !targetUser) {
			return;
		}

		const pagePathName = window.location.pathname;

		const {
			likes,
			last_contacts: lastContacts,
			first_message: firstMessage,
			userid,
		} = targetUser;

		let origin = null;

		if (pagePathName === "/quickmatch" || pagePathName === "/doubletake") {
			origin = "doubletake";
		} else if (pagePathName.match("/profile")) {
			origin = "profile";
		}

		const theyIntrod = !!(
			lastContacts &&
			lastContacts.threadid &&
			firstMessage &&
			firstMessage.body
		);

		const theyLikeYou = !!(likes && (likes.they_like || likes.mutual_like));

		Analytics.logUIEvent(
			Analytics.eventNames.connectionLayerShown,
			{
				data: {
					origin,
					source: likedVia.toLowerCase(),
					"came from": UrlHelpers.getParam("cf"),
					"has intro": theyIntrod ? "yes" : "no",
					"is mutual like": theyLikeYou ? "yes" : "no",
					"target user id": userid,
				},
			},
		);
	}, [likedVia, targetUser]);
}

function Connections(props) {
	const { likes } = props.targetUser;

	const theyLikeYou = !!(likes && (likes.they_like || likes.mutual_like));
	const myThumb = Context.get("thumbnail");

	const [ ref, measured ] = useMeasure();

	useAnalyticEvent(props);

	const springProps = useSpring({
		height: measured.height || 0,
		config: {
			tension: 500,
			friction: 50,
			velocity: 100,
		},
	});

	return (
		<div className="connection-layer">
			<animated.div className="connection-layer-content" style={{ ...springProps }}>
				<div ref={ref}>
					{theyLikeYou &&
						<PostmatchIntro {...props} myThumb={myThumb} />
					}
					{!theyLikeYou &&
						<PrematchIntro {...props} />
					}
				</div>
			</animated.div>
		</div>
	);
}

Connections.propTypes = {
	targetUser: PropTypes.shape({
		likes: PropTypes.object,
	}).isRequired,
	likedVia: PropTypes.string,
};

Connections.defaultProps = {
	likedVia: null,
};

export default Connections;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/index.js